<template>
  <div class="">
    <div class="pagenamPT">
     <h3 class="pagename2">
        {{$t('front.message.allMsg')}}<span class="blc">{{pageInfo.tatal_list_count}}</span>{{$t('front.message.num')}}
     </h3>
    </div>

    <board-filter  @onSearch="onSearch"/>

    <div class="strTablescr">
     <div class="strTablePC">
        <table class="strTablePT">
          <colgroup>
            <col width="10%">
            <col width="10%">
            <col width="50%">
            <col width="20%">
            <col width="10%">
          </colgroup>
          <thead>
            <tr>
              <th>{{$t('front.board.checks')}}</th>
              <th>{{$t('front.board.check')}}</th>
              <th>{{$t('front.board.title')}}</th>
              <th>{{$t('front.board.sendTime')}}</th>
              <th>{{$t('front.board.delete')}}</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="list && list.length > 0">
              <template v-for="item in list" :key="item.msgIdx">
                <tr>
                  <td><input type="checkbox" v-model="item.checked"></td>
                  <td><span class="ocmsg" :class="{'closemsg': item.msgStatus === 'N', 'openmsg': item.msgStatus !== 'N'}"></span></td>
                  <td>
                     <a @click="onMessageClick(item)">
                      <span class="nicon iblbg mr10">{{$t('front.boardCategory.notice')}}</span>
                      {{item.msgTitle}}
                      <span class="newicon ml10">N</span>
                    </a>
                  </td>
                  <td>{{dateFormat(item.sendDate)}}</td>
                  <td><span class="nbicon bgrbg" @click="onRemoveOne(item)">{{$t('front.board.delete')}}</span></td>
                </tr>
              </template>
            </template>
            <template v-else>
              <tr>
              </tr>
            </template>
          </tbody>
        </table>
     </div>
     <!-- <div class="strTableM">
        <div class="strTablePTM">
           <template v-if="list && list.length > 0">
             <template v-for="item in list" :key="item.msgIdx">
               <ul>
                 <li>
                    <em>{{$t('front.board.checks')}}</em>
                    <input type="checkbox" v-model="item.checked">
                 </li>
                 <li>
                    <em>{{$t('front.board.check')}}</em>
                    <span class="ocmsg" :class="{'closemsg': item.msgStatus === 'N', 'openmsg': item.msgStatus !== 'N'}"></span>
                 </li>
                 <li>
                    <em>{{$t('front.board.title')}}</em>
                    <a @click="onMessageClick(item)">
                      <span class="nicon iblbg mr10">{{$t('front.boardCategory.notice')}}</span>
                      {{item.msgTitle}}
                      <span class="newicon rdbg ml10">N</span>
                    </a>
                 </li>
                 <li>
                    <em>{{$t('front.board.sendTime')}}</em>
                    {{dateFormat(item.sendDate)}}
                 </li>
                 <li>
                    <em>{{$t('front.board.delete')}}</em>
                    <span class="nbicon rdbg" @click="onRemoveOne(item)">{{$t('front.board.delete')}}</span>
                 </li>
               </ul>
             </template>
           </template>
           <template v-else>
             <ul>
                <li>{{$t('front.common.notFoundList')}}</li>
             </ul>
           </template>
        </div>
     </div> -->
  </div>

    <div class="applibtns">
      <a @click="onAllCheck">{{ $t('front.board.AllSelect') }}</a>
      <a @click="onRemoveMsg">{{ $t('front.board.AllDelete') }}</a>
      <a @click="onAllRead">{{ $t('front.board.AllRead') }}</a>
    </div>

    <pagination
        :pageNum="pageInfo.page"
        :pageSize="pageInfo.count_per_list"
        :totalCount="pageInfo.tatal_list_count"
        @goToPage="loadList"
    />

  </div>
</template>

<script>
import Pagination from '@/components/ui/Pagination'
import BoardFilter from '@/components/common/BoardFilter'
import { getMsgList, setMsgRead, setMsgUpdate } from '@/api/board'
export default {
  name: 'msg',
  components: { BoardFilter, Pagination },
  data () {
    return {
      list: [],
      searchParam: {
        searchOption: '',
        searchValue: ''
      },
      idxList: []
    }
  },
  created () {
    this.loadList()
  },
  methods: {
    onSearch (value) {
      this.searchParam.searchOption = value.type
      this.searchParam.searchValue = value.text
      this.loadList()
    },
    loadList (page) {
      const params = {
        page: page || this.pageInfo.page
      }
      const searchValue = this.searchParam.searchValue
      if (searchValue) {
        params.searchOption = this.searchParam.searchOption
        params.searchValue = this.searchParam.searchValue
      }
      getMsgList(params).then(response => {
        const result = response.data

        if (result.resultCode === '0') {
          const list = result.data.list
          if (result.data.pageInfo) {
            this.pageInfo = result.data.pageInfo
          }

          for (let i = 0, iLen = list.length; i < iLen; i++) {
            const item = list[i]
            item.checked = false
          }
          this.list = list
        }
      })
    },
    onMessageClick (item, isMobile) {
      item.searchParam = JSON.stringify(this.searchParam)
      this.goPageByName('msgread', item)
    },
    onAllCheck (list) {
      this.allChecked = !this.allChecked
      this.list.forEach(item => {
        item.checked = this.allChecked
      })
    },
    async onRemoveOne (item) {
      const confirm = await this.onConfirm('front.message.confirmDeleteMessageMultiple')
      if (confirm) {
        const params = {
          msgIdx: item.msgIdx,
          recieveId: item.recieveId,
          status: 'N'
        }
        await setMsgUpdate(params).then(response => {
          this.onCheck('front.message.completeDeleteMessage')
          this.loadList()
        })
      }
    },
    async onRemoveMsg () {
      let checkedCount = 0
      let unreadCount = 0
      this.list.forEach(item => {
        if (item.checked) {
          checkedCount++

          if (item.msgStatus === 'N') {
            unreadCount++
          }
        }
      })

      if (unreadCount > 0) {
        this.onCheck('front.message.cannotDeleteMessage')
        return false
      }

      if (checkedCount <= 0) {
        this.onCheck('front.message.noSelectMessage')
        return false
      }
      const confirm = await this.onConfirm('front.message.confirmDeleteMessage')

      if (confirm) {
        for (let i = 0, iLen = this.list.length; i < iLen; i++) {
          const item = this.list[i]
          if (item.checked) {
            const params = {
              msgIdx: item.msgIdx,
              recieveId: item.recieveId
            }
            setMsgUpdate(params).then(response => {
            })
          }
        }
        await this.onCheck('front.message.completeDeleteMessage')
        this.loadList()
      }
    },
    async onAllRead () {
      const confirm = await this.onConfirm('front.message.confirmAllRead')

      if (confirm) {
        const params = {
        }
        setMsgRead(params).then(response => {
          const result = response.data
          if (result.resultCode === '0') {
            this.loadList()
          }
        })
      }
    }
  }
}
</script>

<style src="@/styles/striNew.css"></style>

<style scoped>
/* 쪽지 목록 - 화이트 카드형 보정
   template/script 구조는 유지하고 검색/테이블/버튼 쉐입만 정리 */

.pagenamPT {
  display: flex !important;
  align-items: center !important;
  min-height: 54px !important;
  margin: 20px 0 18px !important;
  padding: 0 !important;
  background: transparent !important;
}

.pagename2 {
  margin: 0 !important;
  color: #111827 !important;
  font-size: 20px !important;
  font-weight: 900 !important;
  letter-spacing: -0.4px !important;
}

.pagename2 .blc {
  margin: 0 3px !important;
  color: #2563eb !important;
  font-weight: 900 !important;
}

/* BoardFilter 검색영역 */
:deep(.board-filter),
:deep(.boardFilter),
:deep(.boardFilterWrap),
:deep(.searchWrap),
:deep(.searchwrap),
:deep(.search-box),
:deep(.schWrap) {
  width: 100% !important;
  min-height: 40px !important;
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  margin: 0 0 22px !important;
  padding: 0 !important;
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
}

/* BoardFilter가 별도 class 없이 바로 렌더링되는 경우 대비 */
.pagenamPT + :deep(div) {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  margin: 0 0 22px !important;
}

:deep(select),
:deep(input[type="text"]),
:deep(input[type="search"]) {
  height: 31px !important;
  padding: 0 12px !important;
  border: 1px solid #d4ddeb !important;
  border-radius: 6px !important;
  background: #ffffff !important;
  color: #263244 !important;
  font-size: 13px !important;
  line-height: 31px !important;
  outline: none !important;
  box-sizing: border-box !important;
  box-shadow: none !important;
}

:deep(select) {
  min-width: 118px !important;
  cursor: pointer !important;
}

:deep(input[type="text"]),
:deep(input[type="search"]) {
  min-width: 210px !important;
}

:deep(input:focus),
:deep(select:focus) {
  border-color: #5d8df6 !important;
  box-shadow: 0 0 0 3px rgba(93, 141, 246, 0.14) !important;
}

:deep(input::placeholder) {
  color: #8b97a8 !important;
}

:deep(button),
:deep(.searchBtn),
:deep(.btn-search) {
  min-width: 31px !important;
  height: 31px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 10px !important;
  border: 0 !important;
  border-radius: 7px !important;
  background: #5bb6b2 !important;
  color: #ffffff !important;
  font-size: 13px !important;
  font-weight: 800 !important;
  cursor: pointer !important;
  box-shadow: 0 5px 10px rgba(91, 182, 178, 0.16) !important;
  box-sizing: border-box !important;
}

.strTablescr {
  width: 100% !important;
  margin-top: 0 !important;
  padding: 0 !important;
  overflow: visible !important;
  background: transparent !important;
  border: 0 !important;
}

.strTablePC {
  width: 100% !important;
  overflow: hidden !important;
  border: 1px solid #dbe3ef !important;
  border-radius: 10px !important;
  background: #ffffff !important;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05) !important;
}

.strTablePT {
  width: 100% !important;
  border-collapse: collapse !important;
  table-layout: fixed !important;
  background: #ffffff !important;
  color: #1f2937 !important;
  font-size: 13px !important;
}

.strTablePT th,
.strTablePT td {
  height: 43px !important;
  padding: 9px 12px !important;
  border: 0 !important;
  border-bottom: 1px solid #dfe6ef !important;
  color: #1f2937 !important;
  text-align: center !important;
  vertical-align: middle !important;
  box-sizing: border-box !important;
}

.strTablePT th {
  height: 45px !important;
  background: #ffffff !important;
  color: #111827 !important;
  font-weight: 900 !important;
  border-bottom: 1px solid #cfd8e5 !important;
}

.strTablePC thead tr {
  border-top: 3px solid #2f6df6 !important;
}

.strTablePT tbody tr {
  background: #ffffff !important;
}

.strTablePT tbody tr:nth-child(2n) {
  background: #f8fafc !important;
}

.strTablePT tbody tr:hover {
  background: #eef6ff !important;
}

.strTablePT tbody tr:last-child td {
  border-bottom: 0 !important;
}

.strTablePT input[type="checkbox"] {
  width: 14px !important;
  height: 14px !important;
  margin: 0 !important;
  accent-color: #2563eb !important;
  cursor: pointer !important;
}

.ocmsg {
  width: 21px !important;
  height: 18px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin: 0 !important;
  border-radius: 3px !important;
  background: #5bb6b2 !important;
  position: relative !important;
}

.ocmsg::before {
  content: '' !important;
  width: 12px !important;
  height: 8px !important;
  border-left: 2px solid #ffffff !important;
  border-bottom: 2px solid #ffffff !important;
  transform: rotate(-45deg) translateY(-1px) !important;
  box-sizing: border-box !important;
}

.ocmsg.openmsg {
  background: #94a3b8 !important;
}

.ocmsg.closemsg {
  background: #5bb6b2 !important;
}

.strTablePT td:nth-child(3) {
  text-align: center !important;
}

.strTablePT td:nth-child(3) a {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 4px !important;
  max-width: 100% !important;
  color: #111827 !important;
  font-weight: 500 !important;
  text-decoration: none !important;
  cursor: pointer !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.strTablePT td:nth-child(3) a:hover {
  color: #2563eb !important;
}

.nicon,
.iblbg {
  min-width: 42px !important;
  height: 21px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin-right: 8px !important;
  padding: 0 8px !important;
  border-radius: 999px !important;
  border: 1px solid #bfdbfe !important;
  background: #dbeafe !important;
  color: #1d4ed8 !important;
  font-size: 12px !important;
  font-weight: 900 !important;
  line-height: 21px !important;
  box-sizing: border-box !important;
}

.newicon {
  min-width: 15px !important;
  height: 15px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin-left: 4px !important;
  padding: 0 3px !important;
  border-radius: 2px !important;
  background: #ef233c !important;
  color: #ffffff !important;
  font-size: 10px !important;
  font-weight: 900 !important;
  line-height: 15px !important;
  box-sizing: border-box !important;
}

.nbicon {
  min-width: 42px !important;
  height: 23px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 9px !important;
  border-radius: 999px !important;
  border: 1px solid #cbd5e1 !important;
  background: #374151 !important;
  color: #ffffff !important;
  font-size: 12px !important;
  font-weight: 900 !important;
  line-height: 23px !important;
  cursor: pointer !important;
  box-sizing: border-box !important;
}

.nbicon:hover {
  background: #1f2937 !important;
}

.applibtns {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 20px !important;
  margin: 58px 0 18px !important;
  padding: 0 !important;
}

.applibtns a {
  min-width: 140px !important;
  height: 34px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 18px !important;
  border: 1px solid #5969d7 !important;
  border-radius: 6px !important;
  background: #5969d7 !important;
  color: #ffffff !important;
  font-size: 14px !important;
  font-weight: 800 !important;
  line-height: 34px !important;
  text-decoration: none !important;
  cursor: pointer !important;
  box-shadow: 0 8px 16px rgba(89, 105, 215, 0.16) !important;
  box-sizing: border-box !important;
}

.applibtns a:hover {
  background: #4656c6 !important;
  border-color: #4656c6 !important;
}

:deep(.partnerPaging),
:deep(.paging),
:deep(.pagination) {
  margin-top: 0 !important;
}

@media (max-width: 1000px) {
  .pagenamPT {
    margin: 16px 0 14px !important;
  }

  .pagename2 {
    font-size: 18px !important;
  }

  .pagenamPT + :deep(div),
  :deep(.board-filter),
  :deep(.boardFilter),
  :deep(.boardFilterWrap),
  :deep(.searchWrap),
  :deep(.searchwrap),
  :deep(.search-box),
  :deep(.schWrap) {
    flex-wrap: wrap !important;
    gap: 8px !important;
  }

  :deep(select),
  :deep(input[type="text"]),
  :deep(input[type="search"]) {
    flex: 1 1 calc(50% - 4px) !important;
    min-width: 0 !important;
  }

  :deep(button),
  :deep(.searchBtn),
  :deep(.btn-search) {
    flex: 0 0 36px !important;
  }

  .strTablePC {
    overflow-x: auto !important;
  }

  .strTablePT {
    min-width: 760px !important;
  }

  .applibtns {
    gap: 10px !important;
    margin: 28px 0 16px !important;
  }

  .applibtns a {
    min-width: 100px !important;
  }
}

@media (max-width: 520px) {
  .applibtns a {
    flex: 1 1 0 !important;
    min-width: 0 !important;
    padding: 0 6px !important;
    font-size: 12px !important;
  }
}
</style>
